"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfo = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _ProductInfoLabel = require("../ProductInfoLabel");
var _Shades = require("../Shades");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductInfo = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    searchPhrase,
    name,
    brand,
    code,
    shades
  } = (0, _contexts.useSearchPreviewProduct)();
  const nameWithSearchPhrase = (0, _react.useMemo)(() => (0, _presentationUtils.boldMatchedText)({
    searchPhrase,
    text: name
  }), [searchPhrase, name]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(`${_constants.PRODUCT_INFO}-${code}`),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductInfoLabel.ProductInfoLabel, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Brand, {
      variant: "overline",
      color: "textSecondary",
      "data-testid": `${getTestId('brand')}-${code}`,
      children: brand ?? ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
      color: "textPrimary",
      "data-testid": `${getTestId('name')}-${code}`,
      children: nameWithSearchPhrase
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Bottom, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "caption",
        color: "textSecondary",
        children: code
      }), shades ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Shades.Shades, {}) : null]
    })]
  });
};
exports.ProductInfo = ProductInfo;
//# sourceMappingURL=ProductInfo.js.map